import { HttpClient } from '@angular/common/http';
import { RemoteLoginProcessor } from './remote-login-processor';

export class CSPLoginProcessor extends RemoteLoginProcessor {
	constructor(http: HttpClient) {
		super(http);
	}

	GetTargetApp() {
		return 'CSPPlatform';
	}
}
